import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";

export function RequireAuth() {
  const { status, pending, user } = useAuth();
  const loc = useLocation();

  if (status === "loading") return <FullPageLoading />;
  if (status === "anonymous") {
    return <Navigate to="/login" replace state={{ from: loc.pathname }} />;
  }

  // v0.2.0 multi-tenancy: pending admins are force-routed to onboarding
  // until they create their org. They can't reach any other page.
  if (user?.is_pending_admin && loc.pathname !== "/onboarding/create-org") {
    return <Navigate to="/onboarding/create-org" replace />;
  }
  if (!user?.is_pending_admin && loc.pathname === "/onboarding/create-org") {
    return <Navigate to="/" replace />;
  }

  if (pending && loc.pathname !== "/pending") {
    return <Navigate to="/pending" replace />;
  }
  if (!pending && loc.pathname === "/pending") {
    return <Navigate to="/" replace />;
  }
  return <Outlet />;
}

export function RequireAdmin() {
  const { status, user } = useAuth();
  if (status === "loading") return <FullPageLoading />;
  if (status === "anonymous") return <Navigate to="/login" replace />;
  if (!user?.is_admin && !user?.is_super_admin) {
    return <Navigate to="/" replace />;
  }
  return <Outlet />;
}

export function RequireManager() {
  const { status, isManager } = useAuth();
  if (status === "loading") return <FullPageLoading />;
  if (status === "anonymous") return <Navigate to="/login" replace />;
  if (!isManager) return <Navigate to="/" replace />;
  return <Outlet />;
}

function FullPageLoading() {
  return (
    <div className="grid min-h-screen place-items-center text-sm text-fg-2">
      Loading…
    </div>
  );
}
